import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueI18n from 'vue-i18n'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

/*
import {
  MdField, MdCheckbox, MdDatepicker,
  MdMenuItem
} from 'vue-material/dist/components'

Vue.use(MdField)
Vue.use(MdCheckbox)
Vue.use(MdDatepicker)
Vue.use(MdMenuItem)
*/

import VueMaterial from 'vue-material'

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))

Vue.use(VueMaterial)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  silentTranslationWarn: true
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
